import { createSelector } from "reselect";

export const unitsSelector = createSelector(state => {
  const stations = state.companies.stations
  const units = [...state.unitsReducer.unitsConfigArr].map(unit => {
    return {
      ...unit,
      operatingStation: stations[unit.idOperating].label,
    }
  })
  return units
}, units => units)